import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminSupportApi = createApi({
    reducerPath: "support",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Support'],
    endpoints: (builder) => ({

        getAllSupportQueries: builder.query({
            query: ({ status, pageno, keyword, limit }) => ({
                url: `/admin/contactus?${status ? `status=${status}&` : ''}pageno=${pageno + 1}&search=${keyword}&limit=${limit}`,
                method: "GET",
            }),
            transformResponse: (res) => res,
            providesTags: ['Support'],
        }),

        getContactUsById: builder.query({
            query: (id) => ({
                url: `/admin/contactus-details/${id}`,
                method: "GET",
            }),
            transformResponse: (res) => res.body,
            providesTags: ['Support'],
        }),

        replySupportQuery: builder.mutation({
            query: (data) => ({
                url: `/admin/contact-us-reply/${data._id}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['Support'],
        }),

        updateSupportQueryStatus: builder.mutation({
            query: ({ _id, data }) => ({
                url: `/admin/support-requests/${_id}`,
                method: 'PUT',
                body: data,
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Support'],
        }),

        deleteSupportQuery: builder.mutation({
            query: (_id) => ({
                url: `/admin/support-requests/${_id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['Support'],
        }),

    }),
});

export const {
    useGetAllSupportQueriesQuery,
    useReplySupportQueryMutation,
    useUpdateSupportQueryStatusMutation,
    useDeleteSupportQueryMutation,
    useGetContactUsByIdQuery
} = adminSupportApi;